module.exports = __webpack_public_path__ + "media/images/emblems/Sion-coat_of_arms-e1624091d70a59a500df7c3f406c03c0.svg";